import script from "./ImageAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./ImageAttachment.vue?vue&type=style&index=0&id=89d3fb32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89d3fb32"]])

export default __exports__